export const webApp = window.Telegram?.WebApp
